import React, { useState } from "react";
import { Form } from "react-bootstrap";
import WarningModal from "./WarningModal";

type InstallerSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  description?: string;
  isInvalid?: boolean;
  errorMessage?: string;
  warningTitle?: string;
  warningMessage?: string;
  id?: string;
  disabled?: boolean;
};

const InstallerSwitch: React.FC<InstallerSwitchProps> = ({
  checked,
  onChange,
  label = "Disponibilizar no instalador",
  description = "Se marcado, esta versão será disponibilizada no instalador para os usuários.",
  isInvalid = false,
  errorMessage = "",
  warningTitle = "Atenção",
  warningMessage = "Ao marcar esta versão como disponível no instalador, as outras versões serão automaticamente desmarcadas. Apenas uma versão pode estar disponível no instalador por vez.",
  id = "instalador",
  disabled = false,
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const [pendingValue, setPendingValue] = useState(false);

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;

    // Se estiver desmarcado e for marcado, mostra o aviso
    if (!checked && newValue) {
      setShowWarning(true);
      setPendingValue(newValue);
      e.preventDefault(); // Previne a mudança do switch até a confirmação
    } else {
      // Se estiver marcado e for desmarcado, apenas atualiza o valor
      onChange(newValue);
    }
  };

  const handleConfirmWarning = () => {
    // Usuário confirmou, atualiza o valor
    onChange(pendingValue);
    setShowWarning(false);
  };

  const handleCancelWarning = () => {
    // Usuário cancelou, mantém o valor anterior
    setShowWarning(false);
  };

  return (
    <>
      <Form.Group className="mb-4" controlId={id}>
        <Form.Check
          type="switch"
          label={label}
          checked={checked}
          onChange={handleSwitchChange}
          isInvalid={isInvalid}
          disabled={disabled}
        />
        <Form.Text className="text-body-tertiary">{description}</Form.Text>
        <Form.Control.Feedback type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>

      <WarningModal
        show={showWarning}
        title={warningTitle}
        message={warningMessage}
        onConfirm={handleConfirmWarning}
        onCancel={handleCancelWarning}
      />
    </>
  );
};

export default InstallerSwitch;
